import { render, staticRenderFns } from "./LoginAuth.vue?vue&type=template&id=87f668cc"
import script from "./LoginAuth.vue?vue&type=script&lang=js"
export * from "./LoginAuth.vue?vue&type=script&lang=js"
import style0 from "./LoginAuth.vue?vue&type=style&index=0&id=87f668cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports